module.exports = __webpack_public_path__ + "img/energy.a3e1472d.svg";